import Image from "next/image";
import Link from "next/link";
import { useTranslation } from "next-i18next";
import { useEffect, useState, memo } from "react";

import { useGetSet } from "@api/hooks/queries/useGetSet";
import BlockTitle from "@components/cms/BlockTitle/BlockTitle";
import { getPageFolderName } from "@config/cms";
import { blurDataURL } from "@config/config";
import Container from "@ui-kit/Container/Container";
import Slider from "@ui-kit/Slider/Slider";
import SliderControls from "@ui-kit/Slider/SliderControls";
import SliderSlides from "@ui-kit/Slider/SliderSlides";

import { typeSlider } from "./datas";
import s from "./GaleryV2Block.module.scss";

const GaleryV2Block = ({ settings, data, updateField }) => {
  const { t } = useTranslation(["common"]);
  const { title, collections } = data;
  const { sliderV2 } = collections;
  const { items } = sliderV2;
  const { blockType } = settings.common;

  const [allItems, setAllItems] = useState([]);

  const [getSet] = useGetSet({ lazy: true });

  useEffect(() => {
    const promises = [];
    const filtered = items.filter((item) => {
      return typeof item.isShow === "boolean" ? item.isShow : true;
    });
    filtered.forEach((item) => {
      if (item.setId) {
        promises.push(
          getSet({
            variables: {
              id: item.setId,
            },
          }),
        );
      }
    });

    Promise.all(promises)
      .then((data) => {
        setAllItems([]);
        let counter = 0;
        filtered.forEach((item) => {
          if (item.setId) {
            const setPages = data[counter].data.getSet.data.map((page) => {
              return {
                title: page.title,
                alt: page.seo.description,
                image: page.seo.thumbnailBig || page.seo.thumbnail,
                description: page.seo.description,
                link: `/${getPageFolderName()[item.setType]}/${page.slug}`,
              };
            });

            setAllItems((slides) => [...slides, ...setPages]);

            counter += 1;

            return;
          }

          setAllItems((items) => [...items, item]);
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }, [items]);

  return (
    <Container className={s.galeryV2}>
      <Container full={false}>
        <section>
          <BlockTitle
            settings={settings}
            field={{ title }}
            onChange={updateField}
            type={blockType}
          />
          <Slider
            collectionType={typeSlider}
            // autoScroll
            className={s.slider}
            startPadding
            slidesCount={allItems.length}
            render={(sliderProps) => (
              <>
                <SliderSlides {...sliderProps} className={s.slides}>
                  {allItems.map((slide, key) => {
                    const { link, title, description, image, alt } = slide;
                    return (
                      <Link href={link} key={key} className={s.slide}>
                        <Image
                          className={s.img}
                          src={image}
                          fill
                          alt={alt}
                          style={{
                            objectFit: "cover",
                            objectPosition: "center",
                          }}
                          // quality={100}
                          // sizes="(max-width: 767px) 320px, 372px"
                          blurDataURL={blurDataURL}
                        />
                        <div className={s.title}>{title}</div>
                        <div title={description} className={s.description}>
                          {description}
                        </div>
                        <div className={s.discover}>{t("discover")}</div>
                      </Link>
                    );
                  })}
                </SliderSlides>
                <div className={s.checkDestinations}>
                  <SliderControls className={s.controls} {...sliderProps} />
                </div>
              </>
            )}
          />
        </section>
      </Container>
    </Container>
  );
};

export default memo(GaleryV2Block);
